import { DashboardData } from 'mobx/storeTypes';
import { forEach } from 'lodash-es';
import { formatDate } from 'utils/dateFormat';
import { getDateColor } from 'utils/dataMappings';
import { SeriesMap } from './periodFilter';

export const adaptDataToSeriesMap = (data: DashboardData.ReviewPeriod[]) => {
  if (data.length === 0) {
    return null;
  }

  const seriesMap: SeriesMap = {};

  forEach(data, (item) => {
    const formattedDate = formatDate(item.start_date);

    seriesMap[formattedDate] = {
      seriesName: formattedDate,
      color: getDateColor(formattedDate),
    };
  });

  return seriesMap;
};

export const adaptDataToEnabledSeries = (
  data: DashboardData.ReviewPeriod[]
) => {
  const enabledSeries: string[] = [];

  forEach(data, (item) => {
    const formattedDate = formatDate(item.start_date);
    enabledSeries.push(formattedDate);
  });

  return enabledSeries;
};
